export const languages = {
  engKey: 'en',
  itKey: 'it',
};
